// extracted by mini-css-extract-plugin
export default {"icons":"style_icons__tP9og","iconWrapper":"style_iconWrapper__7pF4P","iconWrapperBg":"style_iconWrapperBg__ZxHaF","iconWrapperPrimary":"style_iconWrapperPrimary__3lQyw"};